import { gql } from 'apollo-boost'

export const PING_QUERY = gql`
  {
    ping
  }
`
